import { useEffect } from "react";

// Admin
const Admin = () => {
  useEffect(() => {
    window.location.replace(
        "/admin"
    );
  }, []);

  return null;
};

// Export
export default Admin;
